exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fab-button[data-v-5a2a0547]{background:#0098c3 !important;color:#fff !important\n}", ""]);

// exports
